import { useRef } from 'react';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import HeroSection from './sections/HeroSection';
import NewsSection from './sections/NewsSection';
import HomeCollectionSection from './sections/HomeCollectionSection';
import BeddingSection from './sections/BeddingSection';
import LinensSection from './sections/LinensSection';
import BathSection from './sections/BathSection';
import RitualsSection from './sections/RitualsSection';
import CollaborationsSection from './sections/CollaborationsSection';
import TestimonialsSection from './sections/TestimonialsSection';
import Services from '~/ui/components/common/Services';
import { homeServicesMock } from '~/ui/components/common/Services/servicesMock';
import ReadMoreSection from './sections/ReadMoreSection';
import EarnAndBurnSection from './sections/EarnAndBurnSection';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection promotion={promotion} />
      <NewsSection isVisible />
      <HomeCollectionSection />
      <Services items={homeServicesMock} border={false} />
      <BeddingSection />
      <LinensSection />
      <BathSection />
      <RitualsSection />
      <CollaborationsSection />
      <TestimonialsSection />
      <ReadMoreSection />
      <EarnAndBurnSection />
    </div>
  );
};

export default Home;
